var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.70711 0.292893C3.31658 -0.0976311 2.68342 -0.0976311 2.29289 0.292893C1.90237 0.683418 1.90237 1.31658 2.29289 1.70711L16.2929 15.7071C16.6834 16.0976 17.3166 16.0976 17.7071 15.7071C18.0976 15.3166 18.0976 14.6834 17.7071 14.2929L16.2339 12.8197C17.7715 11.5924 18.939 9.9211 19.5424 7.99996C18.2681 3.94288 14.4778 1 10.0002 1C8.37665 1 6.84344 1.38692 5.48779 2.07358L3.70711 0.292893ZM7.96813 4.55391L9.48201 6.0678C9.6473 6.02358 9.82102 6 10.0003 6C11.1048 6 12.0003 6.89543 12.0003 8C12.0003 8.17923 11.9767 8.35296 11.9325 8.51824L13.4463 10.0321C13.7983 9.43658 14.0003 8.74187 14.0003 8C14.0003 5.79086 12.2094 4 10.0003 4C9.25838 4 8.56367 4.20197 7.96813 4.55391Z",
    fill: "#222222",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4541 14.6967L9.74965 11.9923C7.74013 11.8681 6.1322 10.2601 6.00798 8.2506L2.33492 4.57754C1.50063 5.57223 0.856368 6.73169 0.458008 8.00004C1.73228 12.0571 5.52257 15 10.0002 15C10.8469 15 11.6689 14.8948 12.4541 14.6967Z",
    fill: "#222222",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOff);
export default __webpack_public_path__ + "static/media/eye_off.7acf9a8ec1ac71f7d6148fde19dcf688.svg";
export { ForwardRef as ReactComponent };